export function getAssigneeAvatarColors(profiles) {
  const assigneeAvatarColors = useState('assigneeAvatarColors');

  if (!assigneeAvatarColors.value?.length) {
    // Avatar colors for assignees based on creation date
    const colors = [
      '#f97316', // orange-500
      '#f59e0b', // amber-500
      '#eab308', // yellow-500
      '#84cc16', // lime-500
      '#22c55e', // green-500
      '#10b981', // emerald-500
      '#14b8a6', // teal-500
      '#06b6d4', // cyan-500
      '#0ea5e9', // sky-500
      '#3b82f6', // blue-500
      '#6366f1', // indigo-500
      '#8b5cf6', // violet-500
      '#a855f7', // purple-500
      '#d946ef', // fuchsia-500
      '#ec4899', // pink-500
      '#ef4444', // red-500
    ];

    // Sort profiles by creation date
    const sortedProfiles = [...profiles].sort((a, b) =>
      new Date(a.created_at) - new Date(b.created_at)
    );

    // Create a map of profile IDs to colors
    return sortedProfiles.reduce((acc, profile, index) => {
      acc[profile.id] = colors[index % colors.length];
      return acc;
    }, {});
  }

  return assigneeAvatarColors.value;
}